import { render } from "./ClockButtons.vue?vue&type=template&id=1696122f"
import script from "./ClockButtons.vue?vue&type=script&lang=js"
export * from "./ClockButtons.vue?vue&type=script&lang=js"

import "./ClockButtons.vue?vue&type=style&index=0&id=1696122f&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__